export const agent = {
  yqmh: "Invite Blind Box",
  yqzmh: "Invite to Earn Blind Box",
  bfbkj: "100% Prize",
  yqpy: "Invite Friends",
  pywczcrw: "Friends Register and Complete Tasks",
  hdcmhcs: "Get Blind Box Draw Times",
  jllb: "Reward List",
  mhjlbk: "Blind Box Rewards May Include: {text} The specific amount is subject to the actual reward received!",
  kkcs: "Can be opened {value} times",
  mhmx: "Blind Box Details",
  jpmx: "Prize Details",
  hdmhs: "Number of Blind Boxes Received",
  hyjd: "Friends Progress",
  jplx: "Prize Type",
  dbmc: "Token Name",
  ypf: "Distributed",
  wpf: "Not Distributed",
  lq: "Receive",
  zblw: "Peripheral Gifts",
  gxczmh: "Congratulations on winning {amount}, invite new friends, complete the task, and get the blind box",
  lxkflq: "Please contact customer service for peripheral gift rewards",
  shdz: "Delivery address",
  rwmc: "Task name",
  wczt: "Completion status",
  hdmhsl: "Number of blind boxes obtained",
  zblqdz: "Peripheral collection address",
  shr: "Recipient",
  dh: "Phone number",
  xxdz: "Detailed address",
  yqmhhdgz: "Invitation Blind Box Activity Rules",
  yqyl: "1. What is the Biking invitation gift?",
  yhhkxt: "Biking invitation gift is a Biking user feedback system, which aims to give back to all loyal users who identify with Biking and invite friends to join Biking.",
  yqhyhdfhjl: "Biking invitation gift is simple and easy to use. Users only need to invite friends to get rich rewards.",
  cyhdhqjl: "2. What rewards can be obtained by participating in the event and completing tasks?",
  hywcrwhdjl: "The inviter invites friends, and the friends complete the corresponding tasks. The inviter and the invitee can get a blind box and open the blind box to get rewards.",
  mhhdgz: "3. Blind Box Obtaining Rules",
  syrwczc: "1. The invitee completes registration and real-name registration-the invitee gets 1 opening opportunity",
  syrcz: "2. The invitee tops up ≥100USDT - the inviter and the invitee each get 1 chance to open",
  syrcssxf: "3. The invitee's contract fee is ≥30USDT - the inviter and the invitee each get 2 chances to open",
  qqjyl: "4. Option trading volume ≥200USDT - the inviter and the invitee each get 2 chances to open",
  yxjyl: "5. Gamefi trading volume ≥200USDT and the order odds are not less than 1.2 times, and orders with odds less than 1.2 times are not counted - the inviter and the invitee each get 2 chances to open",
  xhmrjyl: "6. Spot buy trading volume ≥500USTD - the inviter and the invitee each get 1 chance to open",
  rwqbwc: "Each time the invitation task is completed, the inviter can get up to 8 opportunities to open the blind box, and the invitees can get up to 9 opportunities to open the blind box. If you invite multiple people, the chances of getting the blind box will increase cumulatively according to the rules.",
  qtsm: "4. Other instructions",
  mhffsj: "1. Blind box distribution time - refresh every 10 minutes",
  jlffsj: "2. Reward distribution time - the backend will manually distribute it once a day at 12 noon",
  syyhjkcj: "3. All users can participate, and there is no conflict with other activities",
  mhcjs: "4. The number of blind box draws will be reset on the 1st of each month",
  yqmts: "Only invite users to become subordinates, and subordinate transactions will generate rebates for you",
  fym: "Rebate code",
  fymts: "Invite and directly open a rebate ratio not higher than your own for subordinate users, and subordinate transactions will allocate rebates for rebates in proportion",
  szfym: "Set rebate code",
  xzfym: "Add rebate code",
  lj: "Link",
  fybl: "Rebate ratio",
  yyqhys: "Number of invited friends",
  sykcjs: "The rest can be created",
  tjlx: "Recommended type",
  bwjs: "5. If any individual or team is found to have engaged in blind box benefits, CoinKing reserves the right to deduct or cancel the account benefit qualification. All users who participate in this benefit are deemed to have accepted the official benefit terms, and CoinKing Exchange reserves the right of final interpretation.",
  swmr: "Set as default",
  cffym: "Rebate code is repeated, please enter the correct rebate code",
  qxtjfym: "Please add the rebate code first",
  xywdbl: "10 <= my rebate ratio",
  qsrdybl: "Please enter the corresponding ratio",
  qsrzqsl: "Please enter the correct value",
  qsrbz: "Please enter the remarks",
  bnbhzf: "Cannot contain special characters or emoticons",
  pfjj: "Distribution rejected",
  pfsb: "Reward distribution failed",
  lxkf: "Please contact customer service for details",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/agent/en.js